import { AuthSource } from './AuthSource';

interface AuthGlobalOptionsType {
  /**
   * Se impostato a true, l'utente verrà reindirizzato alla pagina di selezione
   * del ruolo dopo il login.
   */
  requiresRoleSelection: boolean;
  /**
   * Se impostato a true, l'utente che non ha ancora scelto "per conto di"
   * (`profiloSelezionato.tipo` nullo) resta `isPrelogged` finché non sceglie.
   * Speculare a `requiresRoleSelection`: il criterio è un campo dei dati utente
   * valorizzato dal backend, senza logica applicativa nel modulo Auth.
   */
  requiresLegalEntitySelection: boolean;
  /**
   * Permette di personalizzare la chiave di Storage per l'utente corrente.
   */
  storageKey: string;
  /**
   * Imposta la sorgente di autenticazione predefinita.
   */
  source: AuthSource;
}

const AuthGlobalOptions: AuthGlobalOptionsType = {
  requiresRoleSelection: false,
  requiresLegalEntitySelection: false,
  storageKey: 'fwpauth',
  source: AuthSource.Admin,
};

export function getAuthGlobalOptions() {
  return AuthGlobalOptions;
}

/**
 * Imposta le opzioni globali per il modulo Auth.
 */
export function setAuthGlobalOptions(options: Partial<AuthGlobalOptionsType>) {
  Object.assign(AuthGlobalOptions, options);
}
